import { Modal } from '@mui/material';
import React, { useState, useEffect, useRef } from 'react';
import Swal from 'sweetalert2';
import request from '../../../Helpers/API';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import DeleteIcon from '@mui/icons-material/Delete';

export const ModalCarruselImagenes = ({ open, handleClose, datos, imagenesBD }) => {
    const [imagenesExistentes, setImagenesExistentes] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        if (open) {
            const imagenesProcesadas = imagenesBD.map(img => ({
                id_imagen: img.id_imagen,
                documento: img.documento.startsWith("data:image") ? img.documento : `data:image/${img.extension};base64,${img.documento}`,
                extension: img.extension || "jpg"
            }));

            setImagenesExistentes(imagenesProcesadas.slice(0, 4));
        }
    }, [open, imagenesBD]);

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % (imagenesExistentes.length));
    };

    const handlePrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + imagenesExistentes.length) % (imagenesExistentes.length));
    };


    return (
        <Modal open={open}
            onClose={handleClose} // Esto cierra el modal cuando se hace clic fuera del contenido
        >
            <div className="paliado-imagen-carrusel-modal">
                {/* <div className="imagen-modal-title">
                    <h3>IMÁGENES DE MODELO: {datos !== null ? datos.modelo : ""}</h3>
                    <button className="cerrar-button" onClick={handleClose}>X</button>
                </div> */}
                {/* <div className="imagen-modal-soy-el-titulo-line">
                    <div className="imagen-modal-soy-el-titulo-line-bl"></div>
                    <div className="imagen-modal-soy-el-titulo-line-circle"></div>
                    <div className="imagen-modal-soy-el-titulo-line-br"></div>
                </div> */}

                <div className="slider-box" onClick={() => handleClose()}>
                    <div className="slider-navigation">
                        {/* <button onClick={handlePrev} className="prev-button">{"<"}</button> */}
                        <img
                            src={imagenesExistentes[(currentIndex - 1 + imagenesExistentes.length) % imagenesExistentes.length]?.documento}
                            alt={`Imagen anterior`}
                            className="anterior-foto"
                            onClick={(e) => { e.stopPropagation(); handlePrev(); }}  // Evita que el clic cierre el modal
                        />

                        {/* <div>{imagenesExistentes[currentIndex - 1]?.documento}</div> */}
                        <ul>
                            <li>
                                <div className='img-container'>
                                    <img
                                        src={imagenesExistentes[currentIndex]?.documento}
                                        alt={`Imagen ${currentIndex + 1}`}
                                        className="snapper"
                                        onClick={(e) => e.stopPropagation()}  // Evita que el clic cierre el modal
                                    />
                                </div>
                            </li>
                        </ul>
                        <img
                            src={imagenesExistentes[(currentIndex + 1) % imagenesExistentes.length]?.documento}
                            alt={`Imagen siguiente`}
                            className={`siguiente-foto`} // Animación activada
                            onClick={(e) => { e.stopPropagation(); handleNext(); }}  // Evita que el clic cierre el modal
                        />

                        {/* <button onClick={handleNext} className="next-button">{">"}</button> */}
                    </div>
                </div>
            </div>
        </Modal>
    );
};
